import {HttpClient, HttpXsrfTokenExtractor} from '@angular/common/http';
import {Component, NgZone, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { AdminNotification, getAdminNotificationCount } from '@data/notification/admin-notification';
import { AdminNotificationService } from '@data/notification/admin-notification.service';
import { AuthService } from '@modules/auth/services/auth.service';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import {CommonDataService} from '@shared/services/common-data.service';
import {Auth} from 'aws-amplify';

@Component({selector: 'app-header', templateUrl: './header.component.html', styleUrls: ['./header.component.less']})
export class HeaderComponent implements OnInit {
    
  userName : any;

  menuAccess: any;

  menuItems : any = [];
  submenuMode = [
    {
      name: 'onHover',
      delay: { show: 0, hide: 300 },
    }, {
      name: 'onClick',
      delay: { show: 0, hide: 300 },
    }
  ];

  isAdminThere : boolean=false;
  isAuthShow : boolean;
  userEmail : any;

  adminNotificationList: AdminNotification[]=[];
  adminTotalNotificationCount:number=0; 
  adminManageReleaseDateNotificationCount:number=0; 


  constructor(private router : Router, private http : HttpClient, private xsrfTokenExractor : HttpXsrfTokenExtractor, private commonServices : CommonDataService, private zone : NgZone, private _adminNotfy: AdminNotificationService,
    private authService:AuthService) { 
      const getAccess = this.commonServices.checkAuth;
      if(!getAccess.value){
        this.commonServices.checkAuth.next(JSON.parse(window.localStorage.getItem("mp-serve-auth") || "[]"));
        this.commonServices.userData.next(JSON.parse(window.localStorage.getItem("mpuserdetailslock") || "[]"));
        this.commonServices.userInfo.next(JSON.parse(window.localStorage.getItem("mpUInfo") || "[]"));
      }
      
    this.userName = this.commonServices.userInfo.value.firstName +" "+ this.commonServices.userInfo.value.lastName ;    
       
    const userData = this.commonServices.userData.value;
    const getSectionName = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Home");
    const getSectionName2 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Search");
    const getSectionName3 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Production Status Report");
    const getSectionName5 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Weekly Variance Report");
    const getSectionName6 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Post-Production Summary Report");
    const getSectionName4 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Admin");
    const getSectionName7 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Post-Production Admin");
    if(getSectionName[0].permissionName == "READ/WRITE" || getSectionName[0].permissionName == "READ ONLY"){
      this.menuItems.push({
        id: 'home',
        name: 'Home',
        url: 'home'
    })
    }
    if(getSectionName2[0].permissionName == "READ/WRITE" || getSectionName2[0].permissionName == "READ ONLY"){
      this.menuItems.push({
        id: 'search',
        name: 'Search',
        url: 'search'
    })
    }
    if(getSectionName3[0].permissionName == "READ/WRITE" || getSectionName5[0].permissionName == "READ/WRITE" || getSectionName6[0].permissionName == "READ/WRITE" || getSectionName3[0].permissionName == "READ ONLY" || getSectionName5[0].permissionName == "READ ONLY" || getSectionName6[0].permissionName == "READ ONLY"){
      this.menuItems.push({
        id: 'reports',
        name: 'Reports',
        url: 'reports',
        items: [
          {
            id: 'preview',
            name: 'Production/Post-Production',
            url: 'reports/preview'
          }
        ]
    })
      if (this.commonServices.userInfo.value.userRole.roleId === CommonConstants.FINANCE_AUDITOR_ROLE_ID 
        || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID
        || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.FINANCE_EXEC_ROLE_ID 
        || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.IT_READ_ONLY_ROLE_ID) {
          let data = {
              id: 'gv-sap-recon',
              name: 'GV SAP Recon',
              url: 'reports/gv-sap-recon'
          }

          for (let m of this.menuItems) {
              if (m.id == 'reports') {
                  m.items.push(data);
                  break;
              }
          }
      }

      
    }
    
    if((getSectionName4[0].permissionName == "READ/WRITE" || getSectionName4[0].permissionName == "READ ONLY")
    && this.commonServices.userInfo.value.userRole.roleId != CommonConstants.FINANCE_AUDITOR_ROLE_ID){
      this.isAdminThere=true;
      this.menuItems.push({
        id: 'admin',
        name: 'Admin',
        url: 'admin',
        items: [{
          id: 'manage-publish-dist',
          name: 'Manage Publish',
          url: 'admin/manage-publish-dist'
        },
        {
          id: 'aduit-reports',
          name: 'Audit Reports',
          url: 'admin/audit-logs'
        },
        {
          id: 'manage-projects',
          name: 'Manage Projects',
          url: 'admin/manage-projects'
        },
        {
          id: 'manage-production-entity',
          name: 'Manage Production Entity',
          url: 'admin/manage-production-entity'
        },
        {
          id: 'manageUsers',
          name: 'Manage Users',
          url: 'admin/user/manage-user'
        },
        {
          id: 'pick-list-admin',
          name: 'Picklist Admin',
          url: 'admin/pick-list'
        },
        {
          id: 'manage-release-date',
          name: 'Manage Release Date',
          url: 'admin/manage-release-date'
        }
      ]
      });
      
    }

    if(this.commonServices.userInfo.value.userRole.roleId === CommonConstants.FINANCE_AUDITOR_ROLE_ID){
      
      this.menuItems.push({
        id: 'admin',
        name: 'Admin',
        url: 'admin',
        items: [{
          id: 'manage-publish-dist',
          name: 'Manage Publish',
          url: 'admin/manage-publish-dist'
        },
        {
          id: 'aduit-reports',
          name: 'Audit Reports',
          url: 'admin/audit-logs'
        }]
      });
    }
      
    if(this.commonServices.userInfo.value.userRole.roleId === CommonConstants.POST_PRODUCTION_ADMIN){  
      
        this.menuItems.push({
          id: 'admin',
          name: 'Admin',
          url: 'admin',
          items: [{
            id: 'pick-list-admin',
            name: 'Picklist Admin',
            url: 'admin/pick-list'
          },{
            id: 'manage-release-date',
            name: 'Manage Release Date',
            url: 'admin/manage-release-date'
          }]
        });
        this.fetchAdminNotification();      
        _adminNotfy.fetchInterplanData();
    }


          
  }

  ngOnInit(): void {}

  isShowMenu : any = false;

  Navigate(option : string) {
    if(option=='admin')
      return;
    this.isShowMenu=false;
    this.zone.run(() => {
        this.router.navigate([option]);
    });
  }

  isActive(option : string) { 
    if(this.router.url.slice(1,option.length+1) == option){
      return true;
    }
    return false;
  }



  fetchAdminNotification(){
    this._adminNotfy.isAdminNotificationUpdated.subscribe(r=>{
      if(r){
        this.adminNotificationList=this._adminNotfy.adminNotificationList;
        this.adminTotalNotificationCount=getAdminNotificationCount(this.adminNotificationList,'tabCount',null,null);
        this.adminManageReleaseDateNotificationCount=getAdminNotificationCount(this.adminNotificationList,'tabWise',['manageReleaseDate'],null);
      }
    });
  }

  signOut() {
    this.authService.logout();
  }

}
      

